import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const ServiceConsult = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        // Section becomes visible when it enters 75% of viewport height
        const isInViewport = rect.top <= (window.innerHeight * 0.75);
        setIsVisible(isInViewport);
      }
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    // Initial check
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Calculate the max width for buttons to make them consistent
  const buttonWidth = windowWidth <= 768 ? '100%' : 'auto';
  const staticButtonWidth = windowWidth <= 768 ? '280px' : 'auto';

  const styles = {
    container: {
      position: 'relative',
      height: windowWidth <= 768 ? '400px' : '250px',
      width: '100%',
      marginTop: '-20px',
      overflow: 'hidden',
      opacity: isVisible ? 1 : 0,
      transform: `translateY(${isVisible ? '0' : '20px'})`,
      transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
    },
    backgroundImage: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '100%',
      width: '100%',
      backgroundImage: `url(/bg_7.png)`, // Ensure this image is in public folder
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    content: {
      position: 'relative',
      zIndex: 10,
      height: '100%',
      padding: windowWidth <= 768 ? '24px 16px' : '40px',
      display: 'flex',
      alignItems: 'center',
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: windowWidth <= 768 ? 'column' : 'row',
      justifyContent: 'space-between',
      alignItems: windowWidth <= 768 ? 'center' : 'center',
      maxWidth: '1280px',
      margin: '0 auto',
      width: '100%',
      gap: windowWidth <= 768 ? '24px' : '0',
    },
    textSection: {
      maxWidth: windowWidth <= 768 ? '100%' : '50%',
      textAlign: windowWidth <= 768 ? 'center' : 'left',
      opacity: isVisible ? 1 : 0,
      transform: `translateX(${isVisible ? '0' : '-20px'})`,
      transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
    },
    buttonSection: {
      display: 'flex',
      flexDirection: windowWidth <= 768 ? 'column' : 'row',
      alignItems: 'center',
      gap: '16px',
      width: windowWidth <= 768 ? '100%' : 'auto',
      opacity: isVisible ? 1 : 0,
      transform: `translateX(${isVisible ? '0' : '20px'})`,
      transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
    },
    button: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: windowWidth <= 768 ? '12px 16px' : '14px 20px',
      width: windowWidth <= 768 ? staticButtonWidth : buttonWidth,
      fontSize: windowWidth <= 768 ? '16px' : '18px',
      lineHeight: '20px',
      fontWeight: 500,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
    },
    heading: {
      fontSize: windowWidth <= 768 ? '24px' : '32px',
      fontWeight: 600,
      fontFamily: 'Oswald, sans-serif',
      color: 'white',
      lineHeight: windowWidth <= 768 ? '32px' : '40px',
      margin: 0,
    },
    // button: {
    //   display: 'inline-flex',
    //   alignItems: 'center',
    //   justifyContent: 'center',
    //   padding: windowWidth <= 768 ? '12px 16px' : '14px 20px',
    //   width: windowWidth <= 768 ? staticButtonWidth : buttonWidth,
    //   fontSize: windowWidth <= 768 ? '16px' : '18px',
    //   lineHeight: '20px',
    //   fontWeight: 500,
    //   cursor: 'pointer',
    //   transition: 'all 0.3s ease',
    //   textDecoration: 'none',
    //   whiteSpace: 'nowrap',
    // },
    primaryButton: {
      backgroundColor: '#410684',
      color: 'white',
      borderRadius: '6px',
      fontFamily: 'Oswald, sans-serif',
      border: 'none',
    },
    secondaryButton: {
      backgroundColor: 'transparent',
      fontFamily: 'Oswald, sans-serif',
      backdropFilter: 'blur(8px)',
      color: 'white',
      border: '2px solid rgba(255, 255, 255, 0.8)',
      borderRadius: '6px',
    },
    arrow: {
      marginLeft: '8px',
      fontSize: windowWidth <= 768 ? '16px' : '18px',
    },
  };

  const handleConsultationClick = () => {
    navigate('/contactus');
  };

  const handleSolutionsClick = () => {
    navigate('/solution');
  };

  return (
    <div style={styles.container} ref={sectionRef}>
      <div style={styles.backgroundImage} />
      <div style={styles.overlay} />
      
      <div style={styles.content}>
        <div style={styles.contentWrapper}>
          <div style={styles.textSection}>
            <h1 style={styles.heading}>
              AT EJIL ENTERPRISE, <br /> 
              WE ARE COMMITTED TO BUSINESSES
            </h1>
          </div>
          
          <div style={styles.buttonSection}>
            <button 
              onClick={handleConsultationClick}
              style={{...styles.button, ...styles.primaryButton}}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#410684';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#410684';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              REQUEST A CONSULTATION
              <span style={styles.arrow}>→</span>
            </button>
            
            <button 
              onClick={handleSolutionsClick}
              style={{...styles.button, ...styles.secondaryButton}}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              EXPLORE SOLUTIONS
              <span style={styles.arrow}>→</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceConsult;